module.exports = __webpack_public_path__ + "static/media/akshita_dhoot.68ed846c.png";